module.exports = __webpack_public_path__ + "static/media/app_icon_512.8f53bff8.png";